import React, { useState } from 'react';
import styles from './PreferencesSection.module.css';

/**
 * PreferencesSection Component
 * User preferences (privacy, marketing, etc.)
 */
const PreferencesSection = () => {
  const [hideGamingData, setHideGamingData] = useState(false);
  const [hideUsername, setHideUsername] = useState(false);
  const [marketingEmails, setMarketingEmails] = useState(false);

  return (
    <div className={styles.container}>
      <h3 className={styles.sectionTitle}>Preferences</h3>

      {/* Privacy Preferences */}
      <div className={styles.preferencesGroup}>
        <h4 className={styles.groupTitle}>Privacy Preferences</h4>
        
        <div className={styles.preferenceItem}>
          <div className={styles.preferenceInfo}>
            <div className={styles.preferenceTitle}>Hide my gaming data on profile</div>
          </div>
          <label className={styles.toggle}>
            <input
              type="checkbox"
              checked={hideGamingData}
              onChange={(e) => setHideGamingData(e.target.checked)}
            />
            <span className={styles.slider}></span>
          </label>
        </div>

        <div className={styles.preferenceItem}>
          <div className={styles.preferenceInfo}>
            <div className={styles.preferenceTitle}>Hide my username from public lists</div>
          </div>
          <label className={styles.toggle}>
            <input
              type="checkbox"
              checked={hideUsername}
              onChange={(e) => setHideUsername(e.target.checked)}
            />
            <span className={styles.slider}></span>
          </label>
        </div>
      </div>

      {/* Marketing Preferences */}
      <div className={styles.preferencesGroup}>
        <h4 className={styles.groupTitle}>Marketing Preferences</h4>
        
        <div className={styles.preferenceItem}>
          <div className={styles.preferenceInfo}>
            <div className={styles.preferenceTitle}>Receive marketing promotions by Email</div>
          </div>
          <label className={styles.toggle}>
            <input
              type="checkbox"
              checked={marketingEmails}
              onChange={(e) => setMarketingEmails(e.target.checked)}
            />
            <span className={styles.slider}></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default PreferencesSection;
